import { createRoot } from 'react-dom/client';

import browser from '@openclassrooms/utils/browser';
import { jsonConfig } from 'Modules/dom';
import AppProviders from 'Modules/webapp/components/AppProviders';

import DisclaimersFromTwig from '../components/DisclaimersFromTwig';

function initDisclaimersWithReact(messageContainer) {
  const disclaimerTags = Array.from(
    messageContainer.querySelectorAll('[data-role="disclaimer-message-data"]')
  );

  if (!disclaimerTags.length) {
    return;
  }

  const disclaimers = disclaimerTags.map((disclaimerTag) => jsonConfig(disclaimerTag));

  const root = createRoot(messageContainer);
  root.render(
    <AppProviders productionPrefix="notifications">
      <DisclaimersFromTwig disclaimers={disclaimers} />
    </AppProviders>
  );
}

function index() {
  const messageContainer = browser.document.getElementById('disclaimers-container');
  const messageTargetContainer = browser.document.getElementById('disclaimers-target-container');

  if (!messageContainer) {
    return;
  }

  // [with-disclaimer-target] temporary fix until pages integrate webapp
  if (
    browser.document.getElementById('webapp') ||
    browser.document.querySelector('[with-disclaimer-target]')
  ) {
    initDisclaimersWithReact(messageContainer);
    return;
  }

  messageContainer.style.display = 'block';

  if (messageTargetContainer) {
    messageTargetContainer.appendChild(messageContainer);
  }
}

export default index;
